export type RegulationsMap = Record<string, string[]> | null | undefined;

// Extracts the filename from a provided path.
export const getFileNameFromPath = (filePath: string) => {
  const parts = filePath.split("/");
  return parts[parts.length - 1] || filePath;
};

// Gets the attachment number from the filename.
export const getAttachmentNumber = (fileName: string) => {
  const match = fileName.match(/regulamin(\d+)\.pdf/);
  return match ? match[1] : fileName.replace(".pdf", "");
};

// Returns a sorted list of quarter identifiers.
export const getSortedQuarters = (regulations: RegulationsMap) => {
  if (!regulations || Object.keys(regulations).length === 0) {
    return [];
  }
  return Object.keys(regulations).sort();
};

// Backend always returns format: year_qx (e.g., "2025_q1", "2025_q2", etc.)
export const parseQuarterKey = (
  quarterKey: string,
): { year: string; quarter: string } => {
  const [year, quarter] = quarterKey.split("_");
  return {
    year: year || "",
    quarter: (quarter || "").toLowerCase(),
  };
};

export const getQuarterPeriod = (quarterKey: string): string => {
  const { year, quarter } = parseQuarterKey(quarterKey);
  const periodMap: Record<string, string> = {
    q1: `01-03.${year}`,
    q2: `04-06.${year}`,
    q3: `07-09.${year}`,
    q4: `10-12.${year}`,
  };
  return periodMap[quarter] || quarterKey;
};
